





















import Component from 'vue-class-component';
import {FileUploadDialogRequest} from '@/model/CommonModel';
import '@/plugins/Modal';
import {Mixins, Prop} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import MultiFileInput from '@/components/input/MultiFileInput.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import FileInput from '@/components/input/FileInput.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import DefaultFormMixin from '@/views/DefaultFormMixin';
import CommonValidators from '@/validator/CommonValidators';

interface FileUploadForm {
    data: FileUploadFormData;
    rules: any;
}

interface FileUploadFormData {
    fileName: string;
    file?: File;
}

@Component({
    components: {
        CommonButton,
        MultiFileInput,
        FileInput,
        CommonPromptDialog
    },
    mixins: [DialogEventsMixin, DefaultFormMixin]
})
export default class FileUploadDialog extends Mixins(DialogEventsMixin, DefaultFormMixin) {
    private acceptPattern: string = '*';
    private title: string = '';
    private maxFiles: number = Infinity;
    private dialogVisible = false;
    private onUpload: (context: FileUploadDialog, res: any) => void;
    private onClose: () => void;
    
    private form: FileUploadForm = {
        data: {
            fileName: ''
        },
        rules: {
            fileName: [
                {validator: CommonValidators.required(this), trigger: 'change'}
            ],
        }
    };
    
    get getTitle() {
        return this.title;
    }
    
    get getMaxFiles() {
        return this.maxFiles;
    }
    
    get isVisible() {
        return this.dialogVisible;
    }
    
    public mounted() {
        this.$modal
            .getEventBus()
            .$on('fileUpload', (params: FileUploadDialogRequest) => {
                this.show(params);
            });

        this.$modal.getEventBus().$on('hideFileUploadDialog', () => this.cancel());
    }
    
    public show(params: FileUploadDialogRequest) {
        this.dialogVisible = true;
        const {onUpload, onClose, title, maxFiles, acceptPattern} = params;
        this.acceptPattern = acceptPattern ?? this.acceptPattern;
        this.title = title;
        this.onUpload = onUpload;
        this.onClose = onClose;
        this.maxFiles = maxFiles;
    }
    
    public upload() {
        this.validation(() => {
            this.onUpload(this, this.form.data.file);
        });
    }
    
    public cancel() {
        this.hide();
    }
    
    public hide() {
        this.dialogVisible = false;

        if (this.onClose) {
            this.onClose();
        }
    }
    
    public beforeUpload() {
        this.formDisabled = true;
    }
    
    public afterComplete() {
        this.hide();
    }
    
    public afterError() {
        this.formDisabled = false;
    }

    public afterClosed() {
        this.formDisabled = false;
        this.loading = false;
        this.form.data = {
            fileName: '',
            file: undefined
        };
        (this.$refs.form as any).resetFields();
    }

    public onFileChange(raw: File) {
        this.form.data.file = raw;
    }

    public destroyed() {
        this.$modal.getEventBus().$off('fileUpload');
        this.$modal.getEventBus().$off('hideFileUploadDialog');
    }
}
